import { createAction, createReducer } from 'utils/reducer';


const PATH = 'processingPlants/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_PROCESSING_PLANT = `${PATH}TOGGLE_EDIT_PROCESSING_PLANT`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;


export const PROCESSING_PLANTS = {
    CREATE_PROCESSING_PLANT: `${PATH}CREATE_PROCESSING_PLANT`,
    CREATE_PROCESSING_PLANT_SUCCESS: `${PATH}CREATE_PROCESSING_PLANT_SUCCESS`,
    GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
    GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
    DELETE_PROCESSING_PLANT: `${PATH}DELETE_PROCESSING_PLANT`,
    DELETE_PROCESSING_PLANT_SUCCESS: `${PATH}DELETE_PROCESSING_PLANT_SUCCESS`,
    DELETE_PROCESSING_PLANT_FAIL: `${PATH}DELETE_PROCESSING_PLANT_FAIL`,
    EDIT_PROCESSING_PLANT_SUCCESS: `${PATH}EDIT_PROCESSING_PLANT_SUCCESS`,
    EDIT_PROCESSING_PLANT: `${PATH}EDIT_PROCESSING_PLANT`,
};

// actions
export const processingPlantsActions = {
    disableErrors: createAction(DISABLE_ERRORS),
    toggleForm: createAction(TOGGLE_FORM, 'modal'),
    changeControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
    toggleDelete: createAction(TOGGLE_DELETE, 'id'),
    toggleEdit: createAction(TOGGLE_EDIT_PROCESSING_PLANT, 'item'),
    setInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
    // api
    getStateFromApi: createAction(PROCESSING_PLANTS.GET_STATE_FROM_API),
    createProcessingPlant: createAction(PROCESSING_PLANTS.CREATE_PROCESSING_PLANT, 'controls'),
    editProcessingPlant: createAction(PROCESSING_PLANTS.EDIT_PROCESSING_PLANT, 'id', 'controls'),
    deleteProcessingPlant: createAction(PROCESSING_PLANTS.DELETE_PROCESSING_PLANT, 'id'),
};

const defaultInvalidInputs = {
    name: false,
};

const initialState = {
    formControls: {
        name: '',
    },
    invalidControls: {
        name: false,
    },
    formIsOpen: false,
    deleteIsOpen: false,
    toDeleteId: '',
    toEditId: '',
    edit: false,
    error: false,
};

const processingPlants = createReducer(initialState, {
    [DISABLE_ERRORS](state, action) {
        state.error = false;
    },
    [TOGGLE_FORM](state, action) {
        state[action.modal] = !state[action.modal];
        state.edit = false;
        state.formControls.name = '';
        state.invalidControls = { ...defaultInvalidInputs };
    },
    [CHANGE_CONTROLS](state, action) {
        state.formControls = {
            ...state.formControls,
            ...action.controls,
        };
        state.invalidControls = {
            ...state.invalidControls,
            ...(action.invalidControls || {}),
        };
    },
    [TOGGLE_DELETE](state, action) {
        state.deleteIsOpen = !state.deleteIsOpen;
        state.toDeleteId = action.id;
    },
    [TOGGLE_EDIT_PROCESSING_PLANT](state, action) {
        state.formIsOpen = true;
        state.toDeleteId = '';
        state.toEditId = action.item.id;
        state.formControls.name = action.item.name;
        state.edit = true;
    },
    [SET_INVALID_CONTROLS](state, action) {
        state.invalidControls = {
            ...state.invalidControls,
            ...action.controls,
        };
    },
    // api
    [PROCESSING_PLANTS.CREATE_PROCESSING_PLANT_SUCCESS](state, action) {
        state.formIsOpen = false;
        state.formControls.name = '';
        state.invalidControls = { ...defaultInvalidInputs };
    },
    [PROCESSING_PLANTS.DELETE_PROCESSING_PLANT_SUCCESS](state, action) {
        state.deleteIsOpen = false;
        state.toDeleteId = '';
    },
    [PROCESSING_PLANTS.EDIT_PROCESSING_PLANT_SUCCESS](state, action) {
        state.formControls.name = '';
        state.invalidControls = { ...defaultInvalidInputs };
        state.formIsOpen = false;
        state.toDeleteId = '';
        state.toEditId = '';
        state.edit = false;
    },
});

export default processingPlants;